if (!customElements.get("product-specs-table")) {
  customElements.define(
    "product-specs-table",
    class ProductSpecsTable extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      handleVariantChange(event) {
        const variant = event.data.variant;
        if (!variant) return;

        const skuElement = this.querySelector("[data-spec-sku-value]");
        const weightElement = this.querySelector("[data-spec-weight-value]");
        const skuRow = this.querySelector("[data-spec-sku]");
        const weightRow = this.querySelector("[data-spec-weight]");

        if (skuElement && variant.sku) {
          skuElement.textContent = variant.sku;
          if (skuRow) skuRow.style.display = "";
        } else if (skuRow && !variant.sku) {
          skuRow.style.display = "none";
        }

        if (weightElement && variant.weight) {
          const weightInGrams = variant.weight;
          const weightFormatted =
            weightInGrams >= 1000
              ? `${(weightInGrams / 1000).toFixed(2)} kg`
              : `${weightInGrams} g`;
          weightElement.textContent = weightFormatted;
          if (weightRow) weightRow.style.display = "";
        } else if (weightRow && !variant.weight) {
          weightRow.style.display = "none";
        }
      }
    }
  );
}
